<template>
  <div class="iframe-container">
    <iframe 
      src="https://chat.nxqlhhk.top/" 
      frameborder="0"
      allowfullscreen
      class="embedded-iframe"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'FileChat'
}
</script>

<style scoped>
.iframe-container {
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.embedded-iframe {
  width: 100%;
  height: 100%;
  border: none;
  transform: scale(0.9);
  transform-origin: center center;
}
</style>
